export default __webpack_public_path__ + "static/media/gravelbefore.f1f70885.jpeg";